export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Classes', href: '#classes' },
  { label: 'Innovations', href: '#innovations' },
  { label: 'Admissions', href: '#admissions' },
  { label: 'Gallery', href: '#gallery' },
  { label: 'Contact', href: '#contact' },
];

export const features = [
  {
    title: 'MULTIPLE COURSES',
    desc: 'Explore a world of knowledge with our diverse range of courses. From Science and Math to Art and Music, we have something for every curious mind. Join us and discover the joy of learning in a vibrant and supportive environment!',
    img: '/school-photos/5.webp',
    accent: 'Curious minds, endless discoveries',
  },
  {
    title: 'QUALITY EDUCATION',
    desc: 'At Whiteplains, we are committed to delivering top-notch education that nurtures every child\u2019s potential. Our dedicated teachers, modern facilities, and innovative curriculum ensure a learning experience that is both enriching and inspiring.',
    img: '/school-photos/9.webp',
    accent: 'Championing excellence and growth',
  },
  {
    title: 'EXPERIENCED STAFF',
    desc: 'Our experienced and passionate staff are dedicated to guiding and inspiring our students every step of the way. With their expertise and commitment, they create a nurturing environment where every child can excel and grow.',
    img: '/school-photos/1.webp',
    accent: 'Educators that make a difference',
  },
  {
    title: 'GOOD ENVIRONMENT',
    desc: 'At Whiteplains, we believe in fostering a safe, positive, and inclusive environment for all our students. We stand firmly against bullying and promote kindness and respect in every corner of our school.',
    img: '/school-photos/7.webp',
    accent: 'Safe, positive & inclusive',
  },
];

export const talentSteps = [
  {
    n: '01',
    title: 'Identify Their Interests',
    desc: 'Pay attention to what your child is naturally drawn to. Observe their hobbies, the subjects they enjoy, and activities they get excited about \u2014 this reveals their innate talents.',
  },
  {
    n: '02',
    title: 'Provide Exposure',
    desc: 'Expose your child to a variety of activities and experiences \u2014 music, sports, arts, or science clubs. This helps them discover what they are passionate about.',
  },
  {
    n: '03',
    title: 'Create a Supportive Environment',
    desc: 'Encourage and support your child\u2019s interests. Provide the necessary tools \u2014 instruments, art supplies, or sports equipment. Your enthusiasm boosts their confidence.',
  },
];

export const classes = [
  {
    title: 'Pre-Nursery',
    desc: 'Our Montessori-run Pre-Nursery offers the perfect start for children who aren\u2019t quite ready for formal schooling.',
    img: '/school-photos/8.webp',
    age: 'Ages 2 - 3',
  },
  {
    title: 'Nursery',
    desc: 'Our Montessori-run Nursery gives children a joyful start to school life, developing curiosity and social skills.',
    img: '/school-photos/12.webp',
    age: 'Ages 3 - 5',
  },
  {
    title: 'Primary',
    desc: 'Following the National Curriculum of England, our primary education prepares students for their Pearson Edexcel exams.',
    img: '/school-photos/10.webp',
    age: 'Ages 5 - 11',
  },
  {
    title: 'Secondary',
    desc: 'Secondary education following the English National Curriculum, Lower Secondary Checkpoint and IGCSEs.',
    img: '/school-photos/4.webp',
    age: 'Ages 11 - 16',
  },
  {
    title: 'Foundation / A-Level',
    desc: 'Rooted in the globally renowned British standard, our curriculum prepares students for higher education and beyond.',
    img: '/school-photos/1.webp',
    age: 'Ages 16 - 18',
  },
];

export const testimonials = [
  {
    name: 'David',
    role: 'Primary Student',
    quote:
      'I love Whiteplains British School because it\u2019s fun and exciting. The teachers are kind and make learning interesting. Our classrooms are colorful and full of cool stuff. I enjoy science experiments, art classes and sports. I\u2019m proud to be a student here!',
    img: 'https://whiteplainsbritishschool.com/wp-content/uploads/2025/01/IMG_6067-removebg-preview.png',
    color: '#ffd7b0',
  },
  {
    name: 'Sarah',
    role: 'Secondary Student',
    quote:
      'The best thing about Whiteplains is how everyone is so friendly and caring. I feel like I\u2019m part of a big family. Whiteplains is not just a place where I learn \u2014 it\u2019s a place where I grow, dream and achieve my goals.',
    img: 'https://whiteplainsbritishschool.com/wp-content/uploads/2025/01/DSC_0972-removebg-preview.png',
    color: '#ffe4bf',
  },
  {
    name: 'Jemima & Jane',
    role: 'Primary Students',
    quote:
      'Whiteplains British School is the best place ever! Every morning, I wake up excited to go to school because I know it\u2019s going to be a fun and amazing day. The teachers explain everything so clearly.',
    img: 'https://whiteplainsbritishschool.com/wp-content/uploads/2025/01/IMG_5791-removebg-preview.png',
    color: '#ffd0a3',
  },
];

export const stats = [
  { label: 'Happy Students', value: '850+' },
  { label: 'Expert Teachers', value: '65+' },
  { label: 'Global Partners', value: '20+' },
  { label: 'Years of Excellence', value: '15+' },
];

export const admissionSlides = [
  '/school-photos/2.webp',
  '/school-photos/12.webp',
  '/school-photos/5.webp',
  '/school-photos/8.webp',
  '/school-photos/3.webp',
  '/school-photos/7.webp',
  '/school-photos/10.webp',
  '/school-photos/9.webp',
  '/school-photos/1.webp',
  '/school-photos/4.webp',
  '/school-photos/6.webp',
  'https://whiteplainsbritishschool.com/wp-content/uploads/2025/04/Whiteplains-British-School-Entrance-Day-Examination.png',
  'https://whiteplainsbritishschool.com/wp-content/uploads/2025/04/10.png',
  'https://whiteplainsbritishschool.com/wp-content/uploads/2025/04/4.png',
  'https://whiteplainsbritishschool.com/wp-content/uploads/2025/04/3.png',
  'https://whiteplainsbritishschool.com/wp-content/uploads/2025/04/2.png',
  'https://whiteplainsbritishschool.com/wp-content/uploads/2025/04/14.png',
  'https://whiteplainsbritishschool.com/wp-content/uploads/2025/04/17.png',
  'https://whiteplainsbritishschool.com/wp-content/uploads/2025/04/18.png',
];

export const WHATSAPP_NUMBER = '2348033453457'; // primary international format, no +
export const CONTACT_PHONE_DISPLAY = '0803 345 3457';

// Additional WhatsApp / phone contacts for the school
export const CONTACT_NUMBERS = [
  { intl: '2348033453457', display: '0803 345 3457', whatsapp: true, label: 'Admissions' },
  { intl: '2349053386107', display: '+234 905 338 6107', whatsapp: true, label: 'Enquiries' },
  { intl: '2349048107538', display: '+234 904 810 7538', whatsapp: true, label: 'Support' },
];

export const chatBotReplies = [
  'Hi there! I\u2019m Maxie \u2014 how can I help you today? \uD83D\uDC4B',
  'You can ask me about admissions, classes, or our curriculum.',
  'Great question! Our admissions team responds within 24 hours.',
  'We offer Pre-Nursery through A-Level, following the Cambridge Pathway.',
  'You can register from the \"Register Now\" button at the top of the page.',
  'Thanks for reaching out! Would you like us to call you back?',
];

export const LOGO_URL = 'https://whiteplainsbritishschool.com/wp-content/uploads/2025/01/cropped-cropped-logo.fw_-270x270.png';

export const heroSlides = [
  {
    tag: 'Academic Session 2026 / 2027',
    title: 'Where Curious Minds',
    highlight: 'Become Exceptional Scholars',
    subtitle: 'A Cambridge Pathway school delivering the English National Curriculum from Pre-Nursery through to A-Level \u2014 with rigour, character and global perspective.',
    image: '/school-photos/2.webp',
  },
  {
    tag: 'A Legacy of Excellence',
    title: 'Goodness. Discipline.',
    highlight: 'A Higher Standard of Learning.',
    subtitle: 'Fifteen years of nurturing globally-minded students who lead with integrity, achieve with distinction and serve with purpose.',
    image: '/school-photos/3.webp',
  },
  {
    tag: 'Beyond the Classroom',
    title: 'Character, Curiosity',
    highlight: '& Cambridge Credentials.',
    subtitle: 'World-class facilities, exceptional educators and a curriculum that prepares students for the world\u2019s finest universities.',
    image: '/school-photos/6.webp',
  },
];

// ============================================================
// Whiteplains British School Innovations
// ============================================================
export const innovations = [
  {
    tag: 'INNOVATION 01',
    kicker: 'Educational Gaming Room',
    title: 'Learn by flying, driving, and time-travelling',
    lede:
      'Whiteplains British School launches an Educational Gaming Room where young minds strap into VR simulations to pilot fighter jets, private planes and helicopters, drive supercars, tour geographical hotspots across the globe, and even travel back in time to explore living history.',
    bullets: [
      'VR flight simulators for jets, planes and helicopters',
      'Driving simulators for supercars and off-road vehicles',
      'Immersive geography \u2014 visit Machu Picchu, the Sahara, the Great Wall & more',
      'Time-travel history journeys through Ancient Egypt, Rome & the Space Race',
    ],
    image: 'https://customer-assets-7cd3h4nn.emergentagent.net/job_british-scroll/artifacts/tmk5nyip_cb.jpg',
    imageAlt: 'Whiteplains British School VR Educational Gaming Room \u2014 students in VR headsets flying jets, driving simulators and exploring worlds',
    accent: '#c8942a',
    kind: 'vr',
  },
  {
    tag: 'INNOVATION 02',
    kicker: 'Mr Johnson Okeke \u2014 AI Lecturer',
    title: 'The first AI teacher who never gets tired',
    lede:
      'Whiteplains British School introduces the first AI Lecturer, Mr Johnson Okeke. Students can interact with him one-on-one to learn any subject, ask any question, and grow their skills at their own pace. He is patient, encouraging, and never annoyed \u2014 he just teaches and engages, every single time.',
    bullets: [
      'Any subject, any level \u2014 explained clearly and patiently',
      'One-on-one conversational learning that adapts to each child',
      'Instant answers, worked examples and follow-up quizzes',
      'A calm, encouraging classroom voice \u2014 always available',
    ],
    image: 'https://images.unsplash.com/photo-1614023342667-6f060e9d1e04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxibGFjayUyMG1hbGUlMjB0ZWFjaGVyfGVufDB8fHx8MTc4NDIwMTI1MHww&ixlib=rb-4.1.0&q=85',
    imageAlt: 'Portrait of a warm, confident teacher',
    accent: '#b8331f',
    kind: 'ai',
  },
  {
    tag: 'INNOVATION 03',
    kicker: 'WBS Microfinance Bank',
    title: 'A real bank owned by the school \u2014 built for young investors',
    lede:
      'WBS now runs its own Microfinance Bank inside the school. Students can save, invest, take micro-loans and handle real transactions. They learn to trade stocks in real time and gain hands-on experience with financial investments \u2014 all from a very young age.',
    bullets: [
      'Student savings accounts, micro-loans and micro-transactions',
      'Real-time stock trading lessons and simulated portfolios',
      'Financial literacy curriculum built into every year group',
      'Guided micro-funding for student business ideas',
    ],
    image: 'https://images.unsplash.com/photo-1604594849809-dfedbc827105?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHw0fHxzdHVkZW50JTIwZmluYW5jZXxlbnwwfHx8fDE3ODQyMDEyMzh8MA&ixlib=rb-4.1.0&q=85',
    imageAlt: 'Miniature figure on a stack of coins',
    accent: '#0f7a52',
    kind: 'bank',
  },
];

